<template>
  <div>
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbydateOptions && !loading">
            <apexchart
              ref="reportuserbydate"
              type="area"
              height="350"
              :options="reportuserbydateOptions"
              :series="reportuserbydateSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import StatCard from '../analytics/StatCard'
import DashboardGraphLoading from '../analytics/DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    StatCard,
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  props: ['value', 'date', 'beaconSelect'],
  data() {
    return {
      total_all_user: null,
      reportuserbydateSeries: null,
      total_active_users: null,
      reportuserbydateOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('active users')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },
      loading: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await api.reportUserByDateBeaconsList({
        pageid: this.selectedBot.pageid,
        params: {
          from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
          to_date: dayjs(this.date.end).format('YYYY-MM-DD')
        }
      })

      await this.$nextTick()
      this.total_all_user = response.total_all_user
      this.$emit('input', response.total_all_user)
      let rawdata = response.result
      if (this.beaconSelect) {
        rawdata = rawdata.filter(item => item.hwid === this.beaconSelect.beacon_id)
      }
      var data = rawdata.map(el => {
        return [
          dayjs(el.date_count, 'YYYY-MM-DDT00:00')
            .utcOffset(0, true)
            .valueOf(),
          parseInt(el.total_user)
        ]
      })
      this.reportuserbydateSeries = [{ name: this.$t('active users'), data: data }]

      var max = 0
      if (data && data.length > 0) {
        max = data.reduce((acc, val) => {
          acc = acc === undefined || val[1] > acc ? val[1] : acc
          return acc
        })
      }
      if (this.$refs.reportuserbydate) {
        this.$refs.reportuserbydate.updateOptions({
          yaxis: {
            max: max + 5
          }
        })
      }
      this.$emit('onLoaded', { loading: false, data: this.reportuserbydateSeries })
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/ReportUserByDate.vue